import React, {useState, useEffect, useContext} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import {textTruncateByLength} from 'utils/other';
import {toast} from 'react-toastify';
import {assignNudgeAlerts} from 'utils/api/usersApi';
import DualSelect from 'components/DualSelect';
import SpinnerButton from 'components/SpinnerButton';
import {ErrorContext} from 'contexts/ErrorContext';
import Loader from 'components/Loader';

const AssignNudgeEmailsModal = (props) => {
    const {handleErrors} = useContext(ErrorContext);
    const {user, isOpen, toggle, selectedList, fullList, refreshList, entitiesLoading} = props;
    const [selectedEntities, setSelectedEntities] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        // setSelectedSavedSearches(selectedList);
        setSelectedEntities(selectedList);
    }, [fullList]);


    const handleSubmit = async() => {
        try {
            setSubmitting(true);
            let selectedEntityIds = selectedEntities.map(item => item.id);
            await assignNudgeAlerts(user.id, selectedEntityIds);
            refreshList(true);
            toast.success('Nudge emails successfully assigned');
            setSubmitting(false);
            toggle();
        } catch(err) {
            setSubmitting(false);
            console.log(err);
            handleErrors(err);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="feeds-select-modal" style={{width: '80%', maxWidth: 'none'}}>
            <ModalHeader toggle={toggle}>
                <strong>Assign Nudge Email</strong>
            </ModalHeader>
            <ModalBody>
                <div>User Name: {textTruncateByLength(user.name, 50)}</div>
                <div style={{fontSize: '17.5px', fontWeight: '700', margin: '10px 0'}}>Select Entities</div>
                {entitiesLoading ?
                    <Loader small text="Fetching entity data"/>
                    :
                    <DualSelect
                        selectedList={selectedEntities}
                        fullList={fullList}
                        // groups={userGroups}
                        showAssignAll
                        onSelect={setSelectedEntities}
                        contentType="entities"
                        largeBoxes
                    />
                }
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    style={{minWidth: '80px', marginLeft: '10px'}}
                    // disabled={selectedEntities.length < 1}
                    onClick={handleSubmit}
                    className="btn calltoaction-button"
                    submitting={submitting}
                    title="Assign"
                />
            </ModalFooter>
        </Modal>
    );
};

export default AssignNudgeEmailsModal;
